"use client";

import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { User, Gavel } from '@/components/icons';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';
import { Link } from 'react-router-dom';
import { BidItem } from '@/lib/supabase'; // Import BidItem type
import FlipCounter from './FlipCounter'; // Import FlipCounter

interface ProductBidItemProps {
  bid: BidItem;
}

const ProductBidItem: React.FC<ProductBidItemProps> = ({ bid }) => {
  const username = bid.profiles?.username || 'Usuario Desconocido';
  const avatarUrl = bid.profiles?.avatar_url;

  return (
    <div className="flex gap-3 p-2 rounded-md bg-muted/30">
      <div className="flex-shrink-0">
        <Link to={`/${username}`}>
          <Avatar className="h-8 w-8">
            <AvatarImage src={avatarUrl || undefined} alt={username} />
            <AvatarFallback>
              {username.charAt(0).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        </Link>
      </div>
      <div className="flex-1">
        <div className="flex flex-col gap-0.5">
          <div>
            <Link to={`/${username}`} className="font-semibold text-sm hover:underline">
              @{username}
            </Link>
          </div>
          <div>
            <span className="text-xs text-muted-foreground">
              {formatDistanceToNow(new Date(bid.created_at), { addSuffix: true, locale: es })}
            </span>
          </div>
        </div>
        <p className="text-sm text-foreground mt-1 flex items-center gap-1">
          <Gavel className="h-4 w-4 text-primary" /> Ha ofertado <FlipCounter value={bid.amount} className="text-sm font-semibold" />
        </p>
      </div>
    </div>
  );
};

export default ProductBidItem;